import { metricsBus, QueryType } from "@/common/buses";
import { useSearchStore } from "@/common/store/searchStore";
import { useEffect, useState } from "react";

interface IProps {
  currentTag: string[];
  currentSearchValue: string;
}

export const useSendEvent = ({ currentTag, currentSearchValue }: IProps) => {
  const queryCount = useSearchStore(({ queryCount }) => queryCount);
  const [queryType, setQueryType] = useState<QueryType|undefined>();

  useEffect(() => {
    if (!queryType) {
      return;
    }

    const query = [];

    if (currentTag.length > 0) {
      query.push(currentTag.join(","));
    }

    if (currentSearchValue.length > 0) {
      query.push(currentSearchValue);
    }

    metricsBus.emit("searchQuerySubmitted", {
      query: query.join(" "),
      queryType,
      queryCount,
    });
  }, [queryCount]);

  return {
    setQueryType,
  };
};
